import React from 'react';
import { Button } from '@material-ui/core';
import clsx from 'clsx';

const PickemButton = props => {
  return (
    <Button
      className={clsx(props.classes.submitButton, props.classes.actionButton)}
      style={{
        ...props.submitButtonStyle,
        backgroundColor: props.disabled ? '#e0e0e0' : props.submitButtonStyle.backgroundColor,
      }}
      disabled={props.disabled}
      onClick={() => {
        props.type == 'submittingEntireSeries'
          ? props.submittingEntireSeries()
          : props.type == 'submittingIndividualChapter'
          ? props.submittingIndividualChapter()
          : props.submitChapter(props.current_chapter - props.addOrSubtractNumber);
      }}
    >
      {props.button_name}
    </Button>
  );
};

export default PickemButton;
